import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Radio, FormGroup, ControlLabel } from 'react-bootstrap';
import _ from 'underscore';
import { Map, Marker, InfoWindow } from 'components/maps';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
} from '@cargomatic/ui';

export default class DuplicateLocationModal extends Component {
  static propTypes = {
    addresses: PropTypes.array.isRequired,
    onSelectLocation: PropTypes.func.isRequired,
    show: PropTypes.bool,
    onHide: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const address = _.first(props.addresses);
    this.state = {
      selectedAddress: address.coords,
      zoom: 10,
      center: { lat: address.lat, lng: address.lng },
    };
  }

  handleSubmit = () => {
    const duplicateAddress = this.props.addresses.filter(
      (location) => location.coords === this.state.selectedAddress,
    );
    this.props.onSelectLocation(_.first(duplicateAddress));
  };

  handleLocationSelect = (coords) => {
    this.setState({ selectedAddress: coords });
  };

  render() {
    const { addresses } = this.props;
    if (!addresses) return null;

    const locationRadioButtons = (
      <FormGroup controlId="location_select">
        <ControlLabel>Select an Address</ControlLabel>
        {addresses.map((add, index) => {
          const number = index + 1;
          return (
            <Radio
              key={add.coords}
              name="location_select"
              value={add.coords}
              checked={
                this.state.selectedAddress &&
                this.state.selectedAddress === add.coords
              }
              onChange={() => this.handleLocationSelect(add.coords)}
            >
              {`${number}. ${add.lat}, ${add.lng}`}
            </Radio>
          );
        })}
      </FormGroup>
    );

    return (
      <Dialog
        open={this.props.show}
        onOpenChange={this.props.onHide}
        className="z-[999999]"
      >
        <DialogContent className="sm:max-w-[1080px]">
          <DialogHeader>
            <DialogTitle>{`Select Address - ${addresses[0].address}`}</DialogTitle>
          </DialogHeader>
          <div className="flex" style={{ height: '400px', width: '880px' }}>
            <div className="col-md-6">
              <p>
                Multiple Locations were found with this address. Please select
                the correct one.
              </p>
              <div>{locationRadioButtons}</div>
            </div>
            <div className="col-md-6">
              <div style={{ width: 400, height: 300 }}>
                <Map
                  defaultCenter={this.state.center}
                  defaultZoom={this.state.zoom}
                  width={400}
                  height={300}
                >
                  {addresses.map((address, index) => (
                    <React.Fragment key={index}>
                      <Marker
                        position={{ lat: address.lat, lng: address.lng }}
                      />
                      <InfoWindow
                        position={{ lat: address.lat, lng: address.lng }}
                      >
                        <div>{index + 1}</div>
                      </InfoWindow>
                    </React.Fragment>
                  ))}
                </Map>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={this.props.onHide}
              className="mr-2"
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleSubmit}
              disabled={!this.state.selectedAddress}
              style={{ background: '#21b88e' }}
            >
              Submit
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
